import { ApiNetWork } from '@/network/apiNet';

//测试接口
export function getTest() {
  return ApiNetWork.get('app/encryptionVersion');
}
// 首页-房间数据
export function getHomeRoomData() {
  return ApiNetWork.get('app/encryptionTypeHostRecomm');
}
// 首页-轮播图
export function getSwipe() {
  return ApiNetWork.get('app/encryptionBanner');
}
// 首页-今日推荐
export function encryptionRecommMatch() {
  return ApiNetWork.get('app/encryptionRecommMatch');
}
// 首页-热门球圈
export function getHomeListHotNew() {
  return ApiNetWork.get('app/ballNewsListHome');
}
// 球圈数据
export function getballNewList() {
  return ApiNetWork.get('app/ballNewsList', {
    customer_id: 0,
    token: 0,
    page: 1,
    limit: 200
  });
}
// 首页-主播推荐
export function getTypeRecommend() {
  return ApiNetWork.get('app/encryptionTypeHostRecomm', { is_has_video: '1' });
}

// 赛程
export function encryptionMatch(data: any) {
  return ApiNetWork.get('app/encryptionMatchNew', data);
}

// 球圈详情
export function ballNewsDetail(data: any) {
  return ApiNetWork.get('app/ballNewsDetail', data);
}

// 首页-快讯
export function encryptionQiutxNews(data: any) {
  return ApiNetWork.get("app/encryptionNewsData", data);
}

// 首页-快讯-内容
export function encryptionNewsDetail(data: any) {
  return ApiNetWork.get("app/encryptionNewsDetail", data);
}
